module.exports = __webpack_public_path__ + "static/media/coronavirus.174e9c75.jpeg";